<template>
  <div id="feeds-page">
    <!-- <ThemesBar class="feeds-themes"/> -->
    <Feeds class="feeds-view" :class="{mobile: $vuetify.breakpoint.xsOnly}"/>
    <ButtonUp />
  </div>
</template>

<script>
  // import ThemesBar from '../components/main/ThemesBar'
    import Feeds from '../components/feeds';
    import ButtonUp from '../components/misc/ButtonUp.vue';
    import { mapGetters } from 'vuex';

    export default {
        name: 'FeedsPage',
        components: {
            // ThemesBar,
            Feeds,
            ButtonUp,
        },
        computed:{
            ...mapGetters(["current"])
        },
        created() {
        //console.log("rerender");
        },
    }
</script>

<style lang="scss" scoped>
  #feeds-page{
    opacity: 1;
  }
  .feeds-themes{
    padding: 60px 0px 0px;    
    width: 100%;
    overflow: hidden;
    background: transparent;
    height: 219px !important;
  }
  .feeds-view{
    padding-top: 0; 
    &.mobile{
      padding: 0; 
    }    
  }
</style>